import struct from 'observ-struct';
import xtend from 'xtend';
import moment from 'moment';
import _ from 'underscore';
import util from '../../../lib/store/util';
const Difference = util.Difference
import Formatter from '../../../utils/Formatter';
const FORMATS = Formatter.FORMATS

var defaults = {
    startDateTime: moment().format(FORMATS.apiDateFormat),
    stopDateTime: moment().add(1, 'months').format(FORMATS.apiDateFormat),
    id: ''
};

function ScheduleFilter () {
    var filterState = struct(defaults);
    return filterState;
}

ScheduleFilter.ChangedAttrs = Difference.bind(null, defaults);

// merge new params
ScheduleFilter.Update = function (state, params) {
    state.set(xtend(state(), params));
};

export default ScheduleFilter;
